import {useInfiniteQuery} from '@tanstack/react-query';
import {fetchRecords} from '../services/BindingDriftReconciliationService';
import {moduleConfig} from '../config';

// Module-scoped keys (§8): [module, 'list' | 'detail', ...]. A bare string key
// collides across modules.
export const bindingDriftReportKeys = {
    all: [moduleConfig.entityKey] as const,
    list: (limit: number) => [moduleConfig.entityKey, 'list', {limit}] as const,
    detail: (id: string | undefined) => [moduleConfig.entityKey, 'detail', id] as const,
};

// Page size is a server concern, fixed here, never chosen by the user (§9).
export const PAGE_SIZE = 10;

// The sweep writes one row per day, so a run list does not move under a reader in
// seconds. One minute stops a refetch on every mount and route change; Reload in the
// header is the explicit refresh.
export const STALE_TIME_MS = 60_000;

// FNP-585: read-only module. No mutations — the binding-drift sweep (FNP-502) owns
// the lifecycle. There are no filter variants (the sweep scans the whole platform),
// so the only key dimension is the page size.
export const useBindingDriftReportsInfiniteQuery = () => useInfiniteQuery({
    queryKey: bindingDriftReportKeys.list(PAGE_SIZE),
    queryFn: ({pageParam}: { pageParam: string | null }) =>
        fetchRecords({limit: PAGE_SIZE, nextToken: pageParam}),
    // undefined, never null, when done — null makes react-query refetch forever.
    getNextPageParam: (lastPage) => {
        if (!lastPage || !lastPage.nextToken) return undefined;
        return lastPage.nextToken;
    },
    initialPageParam: null as string | null,
    staleTime: STALE_TIME_MS,
});
